import React from "react";
import classes from "./ContextMenu.module.css";
type Position = { x: number; y: number } | null;
interface contextMenuItemData {
    content: string;
    handle: () => any;
}
interface ContextMenuProps {
    data: contextMenuItemData[];
    position: Position;
    close: React.Dispatch<React.SetStateAction<Position>>;
    contextRef: any;
}
function ContextMenu({ data, position, close, contextRef }: ContextMenuProps) {
    if (!position) return <></>;
    return (
        <div
            className={classes.wrap}
            //@ts-ignore
            ref={contextRef}
            style={{ top: position.y, left: position.x }}
            onMouseLeave={() => {
                close(null);
            }}
            onClick={() => {
                close(null);
            }}
        >
            {data.map((row) => (
                <button
                    key={row.content}
                    className={classes.buttom}
                    onClick={row.handle}
                >
                    {row.content}
                </button>
            ))}
        </div>
    );
}

export default ContextMenu;
